  import apiUrl from '../../../constants'
  import axios from 'axios'
  import CryptoJS from 'crypto-js';
  import {
    Validator
  } from 'vee-validate'
  import VueElementLoading from 'vue-element-loading';
  import PageTracker from '../../../common/PageTrackerHelper'
  import moment from 'moment'
  import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

  export default {
    name: 'RTODTOStickerTracking',
    components: {
      VueElementLoading,
    },
    mixins:[PageTracker],
    data: function() {
      return {
        barcode:'',
        shipmentData:[],
        isLoading: false,
        showTable:false,
        userDataKey : '',
      }
    },
    filters: {
      moment: function(date) {
          if (date == null || date == '')
            return '--'
          return moment(date).format('DD-MM-YYYY HH:mm:ss');
        }
    },
    created: function() {},
    watch: {
      barcode: createClearInputWatcher('barcode'),
    },
    async mounted() {
      this.userDataKey = window.localStorage.getItem('userUniqueKey');
      let validateUser = await this.validateJwtToken();
      var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.username = userdetail.username;
      this.localuserid =  userdetail.userid
      this.hubId = userdetail.hubdetails[0]

      // let TrackerInfo = {
      //     projectname:"Last Mile",
      //     type:"Web",
      //     userid:this.localuserid,
      //     username:this.username,
      //     meta: {
      //         "event":""
      //     }
      // }
      // let result  = this.PageTracker(TrackerInfo);
    },
	methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.$refs.barcode.focus(),
			this.$validator.reset();
      this.errors.clear();
      clearSmartInputStyles(this.$refs.barcode);
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
        if (result) {
					this.shipmentData=[];
					this.showTable=false; this.isLoading=true;
          this.input = {
            FlyerShippingId :  this.barcode.trim(),
            "requestedBy":this.username
          }
					axios({
            method: 'POST',
            url: apiUrl.api_url + 'external/RTO/sticker/get/log',
            data: this.input,
						})
						.then(result => {
							this.showTable=true;
             applySmartInputStyles(this.$refs.barcode, result.data.lossCategorization);
							if (result.data.code == 200) {
								this.shipmentData=result.data.data;
							} else {
								this.$alertify.error(result.data.message)
							}
							this.isLoading=false;
						}, error => {
							this.isLoading=false;
							console.error(error)
						})
					}
				});
		}
	},
}



// WEBPACK FOOTER //
// ./src/views/components/RTODTOStickerTracking/RTODTOStickerTracking.component.js